import { Menu, Sparkles, X } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useSession } from "../lib/session";
import { Brand } from "./Brand";

export function PublicHeader() {
  const { user } = useSession();
  const [open, setOpen] = useState(false);
  return <header className="public-header">
    <Brand priority />
    <div className="mobile-nav-actions"><Link className="premiere-nav mobile-premiere-link" to="/premieres" onClick={() => setOpen(false)}><Sparkles size={14}/>首发剧场</Link><button className="nav-toggle" onClick={() => setOpen(!open)} aria-label={open ? "关闭导航" : "打开导航"}>{open ? <X /> : <Menu />}</button></div>
    <nav className={open ? "open" : ""} onClick={() => setOpen(false)}>
      <Link className="premiere-nav" to="/premieres"><Sparkles size={14}/>首发剧场</Link><a href="/#capabilities">发行能力</a><a href="/#cases">发行作品</a><a href="/#process">合作流程</a><a href="/#contact">商务合作</a>
      {user ? <Link className="nav-cta" to="/workspace">进入工作台</Link> : <><Link to="/login">登录</Link><Link className="nav-cta" to="/register">提交项目</Link></>}
    </nav>
  </header>;
}
